export default (state = {}, {type, payload}) => {
    switch (type) {
        case 'SET_RESOURCE':
            return {
                ...state,
                [payload.id]: payload.value
            };
        case 'ADD_OBJECT_RESOURCE':
            return {
                ...state,
                [payload.id]: {
                    ...state[payload.id],
                    [payload.key]: payload.value,
                }
            };
        case 'ADD_OBJECT_RESOURCES':
            const idObject = {};
            Object.keys(payload.keyValuePairObject).forEach(key => {
                idObject[key] = payload.keyValuePairObject[key];
            });
            return {
                ...state,
                [payload.id]: {
                    ...state[payload.id],
                    ...idObject
                }
            };
        default:
            return state
    }
}
